import React from 'react';
import PropTypes from 'prop-types';
import QdtComponents from 'qdt-components';
import Globals from './Globals';

const options = {
  config: {
    host: 'sense-demo.qlik.com',
    secure: true,
    port: 443,
    prefix: '',
    appId: 'b301fa8f-cf69-4e6a-b366-32d8b1ccdace',
    // appId: 'cff791d8-a2eb-41d4-8831-cb75b84c3eac',
  },
  connections: {
    vizApi: true,
    engineApi: true,
  },
};

const qdtComponents = new QdtComponents(options.config, options.connections);

export default class QdtComponent extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    props: PropTypes.object.isRequired,
  }

  async componentWillMount() {
    const { type, props } = this.props;
    const qDoc = await qdtComponents.qDocPromise;
    // const qApp = await qdtComponents.qAppPromise;
    Globals.settings = QdtComponents.picasso.settings;
    Globals.qdtComponents = QdtComponents.globals;
    if (type === 'SelectionApi' && props.field) {
      await qDoc.clearAll();
      await qDoc.selectAssociations({ qSearchFields: [props.field], qContext: 'CurrentSelections' }, [props.value], 0);
    } else if (type === 'SelectionApi' && props.clearAll) {
      await qDoc.clearAll();
    }
  }

  componentDidMount() {
    const { type, props } = this.props;
    if (type !== 'SelectionApi') {
      qdtComponents.render(type, props, this.node);
    }
  }

  componentDidUpdate() {
  }

  render() {
    return (
      <span ref={(node) => { this.node = node; }} />
    );
  }
}
